import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: '6px',
        justifyContent: 'center',
        alignItems: 'center',
    },
    tab: {
        flex: 1,
        maxWidth: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        height: '28px',
        textTransform: 'none',
    }
}))
